export class ViewPathConstants {
  // Root
  rootViewPath = "/";

  // Public Routes
  landingViewPath = "/";
  loginViewPath = "/login";
  registerViewPath = "/register";
  forgotPasswordViewPath = "/forgot-password";
  otpViewPath = "/verify-otp";
  verifyTOTPViewPath = "/verify-code";
  setupMFAViewPath = "/setup-mfa";
  resetPasswordViewPath = "/changepwd";
  expiryPasswordViewPath = "/expiry-password"
  ssoCallbackViewPath = "/sso/callback";

  // MCP OAuth bridge — see ss-core-service-mcp's Inkfree Authorization
  // Server, which delegates its login/consent screens to these two routes.
  mcpAuthorizeViewPath = "/mcp-authorize";
  awsMarketplaceSetupViewPath = "/aws-marketplace/setup";
  oauthConsentViewPath = "/oauth/consent";

  pageNotFoundViewPath = "/page-not-found";
  registrationSuccessViewPath = "/registered";
  verificationPendingViewPath = "/pending-verification";

  // Authenticated Routes
  dashboardViewPath = "/dashboard";
  oAuthRegisterViewPath = "/account/register/profile";
  createSignRequestsViewPath = `/create/request`;
  createSelfSignRequestPath = "/create/self-sign";
  /** The rebuilt bulk send wizard. The old flow was `/create/request?type=bulkSend`. */
  bulkSendViewPath = `/bulk/new`;
  /** `{bulkBatchViewPath}/{batchId}` — where a send hands off to. */
  bulkBatchViewPath = `/bulk/batch`;
  /** `{bulkBatchViewPath}/{batchId}/queue` — the fixed signer's own run. */
  bulkQueueSegment = `queue`;
  editDraftViewPath = `/edit/draft`;
  updateSignRequestsViewPath = `/update/request`;
  createTemplateViewPath = `/create/template`;
  useTemplateViewPath = `/use/template`;
  updateTemplateViewPath = `/template/update`;
  sentSignRequestsViewPath = `/requests/sent`;
  copySignRequestViewPath = "/copy/request";
  inboxViewPath = `/requests/inbox`;
  settingsRequestsViewPath = `/requests/settings`;
  viewRequestViewPath = `/requests/view`;
  contractSearchViewPath = `/contracts/search`;
  ViewDocumentsPath = "/requests/view-documents";
  ViewSignRequestsViewPath = `${this.sentSignRequestsViewPath}/view`;
  settingsViewPath = "/settings";
  addUserViewPath = `${this.settingsViewPath}/user/add`;
  editUserViewPath = `${this.settingsViewPath}/user/edit`;
  addRolesViewPath = `${this.settingsViewPath}/roles/add`;
  editRolesViewPath = `${this.settingsViewPath}/roles/edit`;

  contactsViewPath = `/contacts`;
  configurationsViewPath = `/configurations`;
  groupsViewPath = `${this.contactsViewPath}/groups`;
  tagsViewPath = `${this.contactsViewPath}/tags`;

  templatesViewPath = `/templates`;
  webFormsViewPath = `/webforms`;
  /** "Build with AI": `/new` starts a design, `/<sessionId>` reopens one. */
  webFormsAiViewPath = `${this.webFormsViewPath}/ai`;
  templateDesignViewPath = `${this.templatesViewPath}/design`;
  integrationsViewPath = `/integration`;

  reportsViewPath = `/reports`;
  recipientDomainsViewPath = `${this.reportsViewPath}/recipient-domains`;
  failedStatsViewPath = `${this.reportsViewPath}/failed-stats`;
  reportingViewPath = `/reporting`;

  myProfileViewPath = `${this.settingsViewPath}/profile`;
  myAccountViewPath = `${this.settingsViewPath}/my-account`;
  securityViewPath = `${this.settingsViewPath}/security`;
  securityPoliciesViewPath = `${this.settingsViewPath}/security-policies`;
  enterpriseSsoViewPath = `${this.settingsViewPath}/enterprise-sso`;
  viewMyPlanViewPath = `${this.settingsViewPath}/my-plan`;
  rolesViewPath = `${this.settingsViewPath}/roles`;
  workspacesViewPath = `${this.settingsViewPath}/workspaces`;
  // Nested per-workspace pages (opened from the Workspaces hub's 3-dot menu, not the left nav).
  workspaceMembersViewPath = `${this.settingsViewPath}/workspaces/:id/members`;
  workspaceRolesViewPath = `${this.settingsViewPath}/workspaces/:id/roles`;
  workspaceDetailsViewPath = `${this.settingsViewPath}/workspaces/:id/details`;
  workspaceBrandingViewPath = `${this.settingsViewPath}/workspaces/:id/branding`;
  usersViewPath = `${this.settingsViewPath}/users`;
  teamViewPath = `${this.settingsViewPath}/team`;
  brandingViewPath = `${this.settingsViewPath}/branding`;
  documentSettingsViewPath = `${this.settingsViewPath}/document-settings`;
  apiKeysViewPath = `${this.settingsViewPath}/api-keys`;
  delegationViewPath = `${this.settingsViewPath}/delegation`;
  viewUserViewPath = `${this.usersViewPath}/view`;
  checkout = `${this.settingsViewPath}/my-plan/checkout`;
  domainsViewPath = `${this.settingsViewPath}`;
  ticketsViewPath = `/tickets`;
  viewTicketsViewPath = `${this.ticketsViewPath}/view`;

  onBoardCheckoutViewPath = `/onboard`;
  onBoardingClient = "/new-user";
  checkYourEmailView = `/onboarding`;

  doSign = "/document/sign/do";
  declineRequest = "/decline/request";
  /** Public link emailed to the in-person host — starts/advances a session without login. */
  inPersonHost = "/in-person/host";
  /** Public landing for a dead SMS short link (CloudFront redirects here with ?c=&r=&e=). */
  linkExpired = "/link-expired";

  renewableDocumentsViewPath = "/renewable-documents";
  renewableDocumentsListViewPath = "/renewable-documents/list";
  insightsViewPath = "/insights";

  reports = "/reports";
  reportsEnvelopes = "/reports/envelopes";
  reportsUsers= "/reports/users";
}

const viewpaths = new ViewPathConstants();
export default viewpaths;
